import { Dispatch, SetStateAction } from 'react';
import axios from 'axios';
import { incorrectToken } from '../../../lib/utils/incorrectToken';
import * as Sentry from "@sentry/react";

interface onLoadListProps {
  setListData: Dispatch<SetStateAction<any[]>>;
  setUserList: Dispatch<SetStateAction<any[]>>;
  setInputList: Dispatch<SetStateAction<any[]>>;
}

export const onLoadList = async ({
  approvalIdx,
  setListData,
  setInputList,
}: onLoadListProps) => {
  const token = sessionStorage.getItem('token');
  //const approvalIdx = sessionStorage.getItem('apartmentRefIdx');
  //const approvalIdx = '1';
  //console.log('SP10-020 결재선 설정 - approvalIdx: ', approvalIdx);
  await axios
    .get(
      // https://dev.mmigroup.co.kr:8020/common/approval/approvalwebadmin/1
      `${process.env.COMMON_URL}/common/approval/approvalwebadmin/${approvalIdx}`,
      {
        headers: { tokenID: token },
      }
    )
    .then(res => {
      //console.log('SP10-020 결재선 설정 - 로드: ', `${process.env.COMMON_URL}/common/approval/approvalwebadmin/${approvalIdx}` );
      try {
        if (res.data.ErrorCode === 0) {
          //console.log('res.data.Data: ', res.data.Data);
          // 1. 깊은 복사를 통해 원본 데이터 복사
          const newData = [...res.data.Data];

          // 2. 실제 데이터가 들어있는 ApprovalWebData 배열을 정렬
          // 첫 번째 요소([0]) 안에 데이터가 있다면 정렬을 수행합니다.
          if (newData[0] && Array.isArray(newData[0].ApprovalWebData)) {
            newData[0].ApprovalWebData.sort((a, b) => {
              // 오름차순: a.OrderNo - b.OrderNo
              // 내림차순: b.OrderNo - a.OrderNo
              return Number(b.OrderNo) - Number(a.OrderNo);
            });
          }

          // 3. 정렬된 전체 데이터를 세팅
          setListData(newData);
          //console.log("정렬 완료 데이터:", newData[0].ApprovalWebData);
          // setUserList(res.data.Data[0].ApprovalWebData);
          setInputList(
            newData[0].ApprovalWebData.map(d => d.ApprovalName)
          );
        } else {
          Sentry.captureMessage(`Server Error : SP10-020 : ErrorCode: ${res.data.ErrorCode}\n\nErrorMsg: ${res.data.ErrorMsg}`);
          alert(`정상적으로 처리되지 않았습니다.\n\nErrorCode: ${res.data.ErrorCode}\n\nErrorMsg: ${res.data.ErrorMsg}`);
        }
        incorrectToken(res);
      } catch (e) {
        Sentry.captureException(e);
        console.error(e);
        console.log(
          `ErrorCode: ${res.data.ErrorCode}, ErrorMsg: ${res.data.ErrorMsg}`
        );
      }
    });
};
